<template>
  <div
    class="lego-date-picker lego-input"
    :class="datePickerClass"
    v-picker-click-outside="onClickOutside"
  >
    <lego-text-field
      ref="fromText"
      class="lego-date-picker__text-field"
      v-model="from.textInput"
      :mask="inputType.replace(/#/g, '%#').replace(/[ymd]/gi, '#')"
      :placeholder="noPlaceholder ? '' : inputType.toUpperCase()"
      :disabled="disabled"
      :readonly="readonly"
      :no-shake="noShake"
      @focus="onFocus(1)"
      @enter="onUpdate(1)"
      @keydown.tab="(e) => onUpdate(1, e)"
      :rules="[validateFromInput]"
      @update:modelValue="changeFromInput"
    /><!--
     -->
    <lego-icon-wrapper
      v-if="!disabled && !readonly"
      class="lego-date-picker__icon-wrapper"
      @click.stop="onClickIcon(1)"
    >
      <lego-icon class="lego-date-picker__icon" icon="calendar" icon-type="df" size="16" />
    </lego-icon-wrapper>
    <template v-if="range || strictRange">
      <scpm-time-picker
        ref="fromTime"
        type="1"
        style="margin-left: 8px"
        v-model="fromTime"
        @pressKey="onKeyPress"
      ></scpm-time-picker>
      <lego-icon-wrapper> ~</lego-icon-wrapper>
      <lego-text-field
        ref="toText"
        class="lego-date-picker__text-field"
        v-model="to.textInput"
        :mask="inputType.replace(/#/g, '%#').replace(/[ymd]/gi, '#')"
        :placeholder="noPlaceholder ? '' : inputType.toUpperCase()"
        :disabled="disabled"
        :readonly="readonly"
        :no-shake="noShake"
        tabindex="-1"
        @focus="onFocus(2)"
        @enter="onUpdate(2)"
        @keydown.tab="(e) => onUpdate(2, e)"
        :rules="[validateToInput]"
        @update:modelValue="changeToInput"
      />
      <lego-icon-wrapper
        v-if="!disabled && !readonly"
        class="lego-date-picker__icon-wrapper"
        @click.stop="onClickIcon(2)"
      >
        <lego-icon class="lego-date-picker__icon" icon="calendar" icon-type="df" size="16" />
      </lego-icon-wrapper>
      <scpm-time-picker
        ref="toTime"
        style="margin-left: 8px"
        type="2"
        v-model="toTime"
      ></scpm-time-picker>
    </template>
    <lego-segment-wrapper
      v-if="preset.length > 0"
      v-model="presetName"
      v-bind="setSegmentWrapperBind"
      class="lego-date-picker__segment-wrapper"
    >
      <template v-for="(item, idx) in preset" :key="idx">
        <lego-segment-button :value="item.action" @click.stop="onClickSegment(item.action)"
          ><!--
                     -->{{ item.label
          }}<!--
                 --></lego-segment-button
        >
      </template>
    </lego-segment-wrapper>

    <div
      v-if="messageShow"
      class="lego-date-picker__message lego-validator__message"
      :class="messageClass"
    >
      <!--glue
        -->{{ messageShow
      }}<!--glue
     -->
    </div>
    <div class="lego-date-picker__calendar" :class="calendarClass" v-show="showFlag">
      <div class="lego-date-picker__calendar__month-area">
        <lego-icon-wrapper @click.stop="onClickPrevMonth">
          <lego-icon icon-type="df" icon="arrow_down" :size="16" />
        </lego-icon-wrapper>
        <div class="lego-date-picker-header">
          <span
            class="lego-date-picker-type"
            @click="modeChange('year')"
            v-show="viewMode === 'day'"
          >
            {{ yearFilterFirst }}
          </span>
          <span
            class="lego-date-picker-type"
            @click="modeChange('month')"
            v-show="viewMode === 'day'"
          >
            {{ monthFilterFirst }}
          </span>
          <span
            class="lego-date-picker-type"
            @click="modeChange('year')"
            v-show="viewMode === 'month'"
          >
            {{ monthFilterFirst }}
          </span>
          <span
            class="lego-date-picker-type"
            @click="year ? modeChange('year') : month ? modeChange('month') : modeChange('day')"
            v-show="viewMode === 'year'"
          >
            {{ monthFilterFirst }}
          </span>
          <!-- <template v-if="showFlag === 2 && viewMode === 'day'">
            -
            <span>
              {{ monthFilterSecond }}
            </span>
          </template> -->
        </div>

        <lego-icon-wrapper @click.stop="onClickNextMonth">
          <lego-icon icon-type="df" icon="arrow_up" :size="16" />
        </lego-icon-wrapper>
      </div>

      <div v-if="viewMode === 'year'" class="lego-date-picker__calendar__date-area">
        <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverYear = ''">
          <template v-for="(years, didx) in decadeCalendar(calendarMonth)" :key="didx">
            <div class="lego-date-picker__calendar__year__row">
              <div class="lego-date-picker__calendar__year__row-content">
                <template v-for="(year, yidx) in years" :key="yidx">
                  <span
                    :class="yearClass(year)"
                    @click.stop="onClickYear(year)"
                    @mouseenter="hoverYear = year"
                    >{{ year }}</span
                  >
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-if="viewMode === 'month'" class="lego-date-picker__calendar__date-area">
        <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverMonth = ''">
          <div
            v-for="(months, yidx) in yearCalendar()"
            :key="yidx"
            class="lego-date-picker__calendar__month__row"
          >
            <div class="lego-date-picker__calendar__month__row-content">
              <template v-for="(month, midx) in months" :key="midx">
                <span
                  :class="monthClass(month)"
                  @click.stop="onClickMonth(month)"
                  @mouseenter="hoverMonth = month"
                  >{{ monthAbbr[month - 1] }}</span
                >
              </template>
            </div>
          </div>
        </div>
      </div>

      <div v-if="viewMode === 'day'" class="lego-date-picker__calendar__range-container">
        <div class="lego-date-picker__calendar__date-area">
          <div class="lego-date-picker__calendar__day lego-date-picker__calendar__row">
            <div class="lego-date-picker__calendar__row-background"></div>
            <div class="lego-date-picker__calendar__row-content">
              <template v-for="(day, idx) in weekDay" :key="idx">
                <span :class="weekDayClass(idx)">{{ day.text }}</span>
              </template>
            </div>
          </div>
          <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverDate = ''">
            <template v-for="(week, wIdx) in monthCalendarFirst" :key="wIdx">
              <div class="lego-date-picker__calendar__week lego-date-picker__calendar__row">
                <div class="lego-date-picker__calendar__row-background">
                  <template v-for="(date, dIdx) in week" :key="dIdx">
                    <div :class="date.rangeColor"></div>
                  </template>
                </div>
                <div class="lego-date-picker__calendar__row-content">
                  <template v-for="(date, dIdx) in week" :key="dIdx">
                    <span
                      :class="dateClass(date, dIdx)"
                      @click.stop="onClickDate(date)"
                      @mouseenter="hoverDate = date.value"
                      >{{ date.text }}</span
                    >
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- <template v-if="showFlag === 2">
          <div class="lego-date-picker__calendar__divider"></div>
          <div class="lego-date-picker__calendar__date-area">
            <div class="lego-date-picker__calendar__day lego-date-picker__calendar__row">
              <div class="lego-date-picker__calendar__row-background"></div>
              <div class="lego-date-picker__calendar__row-content">
                <template v-for="(day, idx) in weekDay">
                  <span :key="idx" :class="weekDayClass(idx)">{{ day.text }}</span>
                </template>
              </div>
            </div>
            <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverDate = ''">
              <template v-for="(week, wIdx) in monthCalendarSecond">
                <div
                  :key="wIdx"
                  class="lego-date-picker__calendar__week lego-date-picker__calendar__row"
                >
                  <div class="lego-date-picker__calendar__row-background">
                    <template v-for="(date, dIdx) in week">
                      <div :key="dIdx" :class="date.rangeColor"></div>
                    </template>
                  </div>
                  <div class="lego-date-picker__calendar__row-content">
                    <template v-for="(date, dIdx) in week">
                      <span
                        :key="dIdx"
                        :class="dateClass(date, dIdx)"
                        @click.stop="onClickDate(date)"
                        @mouseenter="hoverDate = date.value"
                        >{{ date.text }}</span
                      >
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template> -->
      </div>
      <!-- <lego-action-bar class="lego-date-picker__action-bar">
        <template v-slot:left>
          <lego-button tabindex="-1" sm borderless @click.native.stop="onClickToday">{{
            todayText || t('button.today')
          }}</lego-button>
        </template>
        <lego-button tabindex="-1" sm main @click.native.stop="onConfirm">{{
          confirmText || t('button.confirm')
        }}</lego-button>
      </lego-action-bar> -->
    </div>
  </div>
</template>

<script>
const DUMMY_EVENT = {
  preventDefault: () => {}
};

import i18nMixin from '@/mixins/i18n.mixin.js';
import dateTimeMixin from './mixins/dateTime.mixin.js';
import legoDatePicker from '@/lego-component/components/element/legoDatePicker/legoDatePicker.vue';
import moment from 'moment';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';

const { dateFormat } = useDateTimeFormat();

export default {
  name: 'scpm-date-time-picker',
  extends: legoDatePicker,
  emits: ['changeInputDate'],
  props: {
    todayText: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: null
    },
    month: {
      type: Boolean,
      default: false
    },
    year: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: dateFormat
      // validator: val => {
      //   return (
      //     /^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(val) &&
      //     val.match(/y{1,4}/gi).length === 1 &&
      //     val.match(/m{1,2}/gi).length === 1 &&
      //     val.match(/d{1,2}/gi).length === 1
      //   );
      // },
    },
    modelType: {
      type: String,
      default: 'YYYY-MM-DD'
      // validator: val => {
      //   if (/^(date|array)$/i.test(val)) {
      //     return true;
      //   }
      //   return (
      //     /^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(val) &&
      //     val.match(/y{1,4}/gi).length === 1 &&
      //     val.match(/m{1,2}/gi).length === 1 &&
      //     val.match(/d{1,2}/gi).length === 1
      //   );
      // },
    },
    readonly: { type: Boolean, default: false },
    minDate: {
      type: String,
      default: '1970-01-01'
    },
    maxDate: {
      type: String,
      default: '9999-12-31'
    }
  },
  mixins: [i18nMixin, dateTimeMixin],
  data() {
    return {
      from: {
        actualDate: '', // YYYY-MM-DD // always equal to v-modal value but form of YYYY-MM-DD
        textInput: '', // only Numbers. YMD order depends on inputType // text-field value
        selected: '' // YYYY-MM-DD // calendar selected value. equal to textInput but form of YYYY-MM-DD
      },
      fromTime: '',
      to: {
        actualDate: '', // YYYY-MM-DD // always equal to v-modal value but form of YYYY-MM-DD
        textInput: '', // only Numbers. YMD order depends on inputType // text-field value
        selected: '' // YYYY-MM-DD // calendar selected value. equal to textInput but form of YYYY-MM-DD
      },
      toTime: '',
      default: {
        size: 'medium'
      },
      viewMode: 'day',
      weekDay: [
        { text: 'S', value: 'SUN' },
        { text: 'M', value: 'MON' },
        { text: 'T', value: 'TUE' },
        { text: 'W', value: 'WED' },
        { text: 'T', value: 'THU' },
        { text: 'F', value: 'FRI' },
        { text: 'S', value: 'SAT' }
      ],
      hoverMonth: '',
      hoverYear: '',
      inputCurrToDateRange: '',
      isSetCalender: true
    };
  },
  mounted() {
    if (this.month) {
      this.viewMode = 'month';
    }
    if (this.year) {
      this.viewMode = 'year';
    }
  },
  watch: {
    fromTime(value) {
      this.updateTime(value, 'from');
    },
    toTime(value) {
      this.updateTime(value, 'to');
    },
    modelValue: {
      immediate: true,
      deep: true,
      handler(value) {
        // from.actualDate & to.actualDate only controlled by this handler. they must be equal to v-model
        if (!value.length) return;
        const dateArr = value.map((item) => item.split(' ')[0]);
        const timeArr = value.map((item) => item.split(' ')[1]);
        timeArr[0] = timeArr[0] || this.fromTime;
        timeArr[1] = timeArr[1] || this.toTime;
        if (!this.today) {
          this.currTime = new Date();
          this.today = this.dateToYmd(this.currTime);
        }
        this.initDate(dateArr, timeArr, value);
      }
    },
    showFlag(newFlag) {
      let tmp;
      if (newFlag === 1) {
        if (this.isRange) {
          // this.to.textInput = '';
          // this.to.selected = '';
        }
        if (this.from.selected) {
          tmp = this.from.selected;
        } else {
          tmp =
            this.today < this.minDate
              ? this.minDate
              : this.today > this.maxDate
              ? this.maxDate
              : this.today;
        }
        tmp = tmp.split('-');
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      } else if (newFlag === 2) {
        if (this.to.selected) {
          tmp = this.dateToYmd(this.ymdToDate(this.to.selected, 0, 0, 0));
        } else if (this.from.selected) {
          tmp = this.from.selected;
        } else {
          tmp =
            this.today < this.minDate
              ? this.minDate
              : this.today > this.maxDate
              ? this.maxDate
              : this.today;
        }
        tmp = tmp.split('-');
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      }
    }
  },
  computed: {
    monthFilterFirst() {
      switch (this.viewMode) {
        case 'day':
          return this.monthAbbr[parseInt(this.calendarMonth[1]) - 2 + 1];
        case 'month':
          return this.monthFilter(this.calendarMonth, 1);
        case 'year':
          return this.monthFilter(this.calendarMonth, 1);
        default:
          break;
      }
      return false;
    },
    yearFilterFirst() {
      switch (this.viewMode) {
        case 'day':
          return this.calendarMonth[0];
        case 'month':
          return this.monthFilter(this.calendarMonth, 1);
        case 'year':
          return this.monthFilter(this.calendarMonth, 1);
        default:
          break;
      }
      return false;
    }
  },
  methods: {
    initDate(dateArr, timeArr, datetimeArr) {
      let rtn, targetMonth, validVal, validTime;
      if (this.isRange) {
        validVal = this.toValidRange(dateArr);
        if (this.from.actualDate !== validVal[0] || this.from.selected !== validVal[0]) {
          this.from.actualDate = validVal[0];
          this.from.textInput = this.ymdToText(
            this.from.actualDate,
            this.inputType.replace(/[^ymd]/gi, '')
          );
          this.from.selected = validVal[0];
        }
        if (this.to.actualDate !== validVal[1] || this.to.selected !== validVal[1]) {
          this.to.actualDate = validVal[1];
          this.to.textInput = this.ymdToText(
            this.to.actualDate,
            this.inputType.replace(/[^ymd]/gi, '')
          );
          this.to.selected = validVal[1];
        }
        if (validVal[1]) {
          targetMonth = validVal[1].split('-');
          // targetMonth[1] = parseInt(targetMonth[1]) - 1;
          targetMonth[1] = parseInt(targetMonth[1]);
        } else if (validVal[0]) {
          targetMonth = validVal[0].split('-');
        }
        validTime = this.validTimeArr(timeArr);
        if (!this.isEqualArray(this.presetVal, validVal)) this.presetName = '';

        rtn = [
          `${this.ymdToModel(validVal[0])}${!validVal[0] ? '' : ' ' + validTime[0]}`,
          `${this.ymdToModel(validVal[1])}${!validVal[1] ? '' : ' ' + validTime[1]}`
        ];

        if (!this.isEqualArray(datetimeArr, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else if (this.isMounted) {
          this.validateOnEvent();
        }
      } else {
        validVal = this.modelToYmd(dateArr);
        validVal = this.toValidYmd(validVal);
        if (this.from.actualDate !== validVal) {
          this.from.actualDate = validVal;
          this.from.textInput = this.ymdToText(
            this.from.actualDate,
            this.inputType.replace(/[^ymd]/gi, '')
          );
          this.from.selected = validVal;
        }

        if (validVal) {
          targetMonth = validVal.split('-');
        }

        if (this.presetVal !== validVal) this.presetName = '';

        rtn = this.ymdToModel(validVal);
        if (!this.isEqualModel(dateArr, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else if (this.isMounted) {
          this.validateOnEvent();
        }
      }
      if (!targetMonth) {
        let date = this.today;
        if (date < this.minDate) {
          date = this.minDate;
        }
        if (date > this.maxDate) {
          date = this.maxDate;
        }
        targetMonth = date.split('-');
      }
      this.setHourMinutes(validTime);
      if (this.isSetCalender) {
        this.setCalendarMonth([parseInt(targetMonth[0]), parseInt(targetMonth[1])]);
      } else {
        this.isSetCalender = true;
      }
    },
    validTimeArr(timeArr) {
      let newTimeArr;
      if (!(Array.isArray(timeArr) && timeArr.length === 2)) {
        return ['', ''];
      }
      newTimeArr = [timeArr[0], timeArr[1]];
      if (this.strictRange && !(newTimeArr[0] && newTimeArr[1])) {
        return ['', ''];
      }
      newTimeArr[0] = this.toValidHHmm(newTimeArr[0]);
      newTimeArr[1] = this.toValidHHmm(newTimeArr[1]);

      return newTimeArr;
    },
    toValidHHmm(HHmm) {
      if (!HHmm || typeof HHmm !== 'string') {
        return '';
      }
      let HM = HHmm.split(':');
      if (parseInt(HM[0]) >= 24) {
        HHmm = '23:59';
      }
      if (parseInt(HM[1]) >= 60) {
        HHmm = `${HM[0]}:59`;
      }
      return HHmm;
    },
    setHourMinutes(value) {
      this.fromTime = value[0];
      this.toTime = value[1];
    },
    onKeyPress(type) {
      if (type === '1') {
        if (!this.from.selected) {
          this.$refs['fromText'].focus();
          return;
        }
        this.$refs['toText'].focus();
      }
    },
    updateTime(value, type) {
      if (!this.modelValue.length) return;
      const model = this.modelValue.map((item) => item.split(' ')[0]);
      let date = [];
      if (type == 'from') {
        date = [model[0] + ' ' + value, this.modelValue[1]];
      } else {
        date = [this.modelValue[0], model[1] + ' ' + value];
      }
      this.$emit('update:modelValue', date);
    },
    onFocus(idx) {
      if (idx === 2 && this.strictRange && !this.from.selected) {
        this.$refs['from-text'].focus();
        return;
      }
      this.showFlag = idx;
    },
    onClickIcon(idx) {
      if (this.disabled) return;
      this.showFlag = this.showFlag === idx ? 0 : idx;
    },
    inputToYmd(input) {
      if (!input || typeof input !== 'string') {
        return '';
      }
      let inputFormat = this.inputType.replace(/[^ymd]/gi, '').toUpperCase();
      let sIdx = inputFormat.indexOf('Y');
      let y4Flag = inputFormat.indexOf('YYYY') !== -1;
      let YYYY = '',
        tmp = '';
      if (input.length === 4) {
        // no YYYY or YY
        if (y4Flag) {
          YYYY = input;
          if (this.viewMode === 'month') {
            tmp = YYYY + '01';
          } else if (this.viewMode === 'year') {
            tmp = YYYY;
          } else {
            tmp = YYYY + '0101';
          }
        } else {
          tmp = input.slice(0, sIdx) + YYYY.slice(2) + input.slice(sIdx);
        }
      } else if (input.length === 6) {
        // YY
        if (y4Flag) {
          // YYYY = input.slice(sIdx, sIdx + 2);
          // YYYY = parseInt(YYYY) < 70 ? '20' + YYYY : '19' + YYYY;
          YYYY = input.slice(sIdx, sIdx + 4);
          if (this.viewMode === 'month') {
            tmp = YYYY + input.slice(4);
          } else {
            tmp = YYYY + input.slice(4) + '01';
          }
        } else {
          tmp = input;
        }
      } else if (input.length === 8) {
        // YYYY
        if (y4Flag) {
          tmp = input;
        } else {
          YYYY = input.slice(sIdx, sIdx + 4);
          tmp = input.slice(0, sIdx) + YYYY.slice(2) + input.slice(sIdx + 4);
        }
      } else {
        return '';
      }
      return this.textToYmd(tmp, inputFormat);
    },
    validateInputDate(input) {
      const regex = /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/;

      const replaceKrCb = (match, year, month, day) => {
        month = month.padStart(2, '0');
        day = day.padStart(2, '0');
        return `${year}${month}${day}`;
      };

      const replaceEnCb = (match, month, day, year) => {
        const today = new Date();
        if (match.length === 4) {
          month = year.substring(0, 2);
          day = year.substring(2, 4);
          year = today.getFullYear();
        }

        return `${month}${day}${year}`;
      };

      const regexFormatDate = {
        'YYYY-MM-DD': { regex: /^(\d{4})(\d{0,2})(\d{0,2})$/, callback: replaceKrCb },
        'MM-DD-YYYY': { regex: /^(\d{0,2})(\d{0,2})(\d{4})$/, callback: replaceEnCb }
      };

      if (regex.test(input) && input.length === 8) {
        return input;
      }

      if (dateFormat === 'MM-DD-YYYY') {
        switch (true) {
          case input.length === 1:
            input = input.padStart(2, '0') + '01';
            break;
          case input.length === 2:
            input = input + '01';
            break;
          case input.length === 3:
            input = input.slice(0, 2) + '0' + input.slice(2);
            break;

          default:
            break;
        }
      }

      let date = input.replace(
        regexFormatDate[dateFormat].regex,
        regexFormatDate[dateFormat].callback
      );

      return date;
    },
    onUpdate(idx, tabEvent = DUMMY_EVENT) {
      if (tabEvent.shiftKey) {
        if (idx === 1) this.from.textInput = this.ymdToInput(this.from.actualDate);

        this.showFlag = 0;
        return;
      }
      // textInput is updated
      let tmp,
        rtn = ['', ''],
        newValue;
      if (this.isRange && idx === 1) {
        // range date picker && on update 'from' text
        newValue = this.inputToYmd(this.from.textInput);
        const {
          fromTime: {
            $refs: {
              hour: {
                $refs: { input }
              }
            }
          }
        } = this.$refs;
        if (newValue !== '' || this.from.textInput) {
          newValue = this.inputToYmd(this.validateInputDate(this.from.textInput));
          newValue = this.toValidYmd(newValue);
          // proper input received
          this.setFromTextInput(newValue);
          if (!this.isError) {
            input.focus();
          }
          this.showFlag = 0;
          tabEvent.preventDefault();
          this.onConfirm();
          return;
        }

        if (!this.strictRange) {
          // empty input but want to enter 'to' date first. (only when strictRange false)
          // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
          this.from.selected = '';
          if (!this.isError) {
            input.focus();
          }
          this.showFlag = 0;
          tabEvent.preventDefault();
          this.onConfirm();
          return;
        }
        // strictRange true
        if (!this.isEqualArray(rtn, [this.from.selected, this.to.selected])) {
          // when strictRange true, empty input make selected date clear.
          this.from.selected = '';
          this.to.selected = '';
          tabEvent.preventDefault();
          return;
        }
        // already clear, update v-model & close calendar
        this.onConfirm();
      } else if (!this.isRange) {
        // single date picker
        newValue = this.inputToYmd(this.from.textInput);
        if (newValue !== '') {
          newValue = this.toValidYmd(newValue);
          // proper input received
          if (newValue !== this.from.selected) {
            this.setFromTextInput(newValue);
            tabEvent.preventDefault();
          }
          this.onConfirm();
          // if selected date is already set, update v-model & close calendar
          return; // not execute e.preventDefault
        } else if (this.from.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.from.textInput = this.ymdToInput(this.from.actualDate);
          tabEvent.preventDefault();
          return;
        } else if (this.from.selected) {
          // empty input
          this.from.selected = '';
          tabEvent.preventDefault();
          return;
        }
        // already clear, update v-model & close calendar
        this.onConfirm();
      } else {
        // idx = 2
        // range date picker && on update 'to' text
        const {
          toTime: {
            $refs: {
              hour: {
                $refs: { input }
              }
            }
          }
        } = this.$refs;
        newValue = this.inputToYmd(this.validateInputDate(this.to.textInput));
        newValue = this.toValidYmd(newValue);
        if (newValue !== '' && this.strictRange) {
          // proper input received & strictRange true
          if (!this.from.selected) {
            // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
            this.$refs['from-text'].focus();
            tabEvent.preventDefault();
            return;
          }
          if (this.from.selected > newValue) {
            // 'to' date input is earlier than 'from' date -> update 'from' date as received input.
            this.setFromTextInput(newValue);
            this.to.textInput = '';
            this.to.selected = '';
            tabEvent.preventDefault();
            return;
          }
          if (newValue !== this.to.selected) {
            // update selected 'to' date as received input.
            this.to.textInput = this.ymdToInput(newValue);
            this.to.selected = newValue;
            this.setToTextInput();
            tabEvent.preventDefault();
            return;
          }
          // selected date already updated, update v-model & close calendar
          this.onConfirm();
          return; // not execute e.preventDefault
        } else if (newValue !== '' && newValue !== this.to.selected) {
          // proper input received & strictRange false -> make selected 'to' date as received input
          this.to.textInput = this.ymdToInput(newValue);
          this.to.selected = newValue;
          this.setToTextInput();
          tabEvent.preventDefault();
          this.onConfirm();
          if (!this.isError) {
            input.focus();
          }
          return;
        } else if (newValue !== '') {
          // proper input received & strictRange false & selected 'to' date already updated
          // -> update v-model & close calendar
          tabEvent.preventDefault();
          this.onConfirm();
          if (!this.isError) {
            input.focus();
          }
          return; // not execute e.preventDefault
        } else if (this.to.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.to.textInput = this.ymdToInput(this.to.actualDate);
          tabEvent.preventDefault();
          if (!this.isError) {
            input.focus();
          }
          this.showFlag = 0;
          return;
        } else if (this.strictRange || this.to.selected) {
          // empty input recieved -> clear selected 'to' date
          this.to.selected = '';
          tabEvent.preventDefault();
          this.onConfirm();
          if (!this.isError) {
            input.focus();
          }
          return;
        }
        // selected 'to' date already cleared & strictRange is false -> update v-model & close calendar
        this.onConfirm(); // not execute e.preventDefault
      }
    },
    ymdToText(val, textFormat) {
      let tmp, rtn;
      // valid val?
      if (!val || typeof val !== 'string') {
        return '';
      }
      tmp = val.split('-');
      if (tmp.length !== 3) {
        return '';
      }
      // valid textFormat?
      // if (
      //   !/^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(textFormat) ||
      //   textFormat.match(/y{1,4}/gi).length !== 1 ||
      //   textFormat.match(/m{1,2}/gi).length !== 1 ||
      //   textFormat.match(/d{1,2}/gi).length !== 1
      // ) {
      //   console.error('[LEGO-DATE-PICKER] invalid text format is given: ' + textFormat);
      //   return '';
      // }
      rtn = textFormat.toUpperCase();
      rtn = rtn.replace('YYYY', tmp[0]);
      rtn = rtn.replace('YY', tmp[0].slice(2));
      rtn = rtn.replace('MM', tmp[1]);
      rtn = rtn.replace('DD', tmp[2]);
      return rtn;
    },
    onClickDate(date) {
      if (date.state === 'prev') {
        this.onClickPrevMonth();
      } else if (date.state === 'next') {
        this.onClickNextMonth();
      }
      if (this.showFlag === 1) {
        const {
          fromTime: {
            $refs: {
              hour: {
                $refs: { input }
              }
            }
          }
        } = this.$refs;
        this.from.textInput = this.ymdToInput(date.value);
        this.from.selected = date.value;
        this.onConfirm();
        if (this.isRange) {
          input.focus();
        }
      } else if (this.showFlag === 2) {
        const {
          toTime: {
            $refs: {
              hour: {
                $refs: { input }
              }
            }
          }
        } = this.$refs;
        if (this.from.selected && this.to.selected) {
          this.to.textInput = '';
          this.to.selected = '';
          this.to.textInput = this.ymdToInput(date.value);
          this.to.selected = date.value;
          input.focus();
        } else if (this.from.selected) {
          if (date.value < this.from.selected) {
            this.from.textInput = this.ymdToInput(date.value);
            this.from.selected = date.value;
          } else {
            this.to.textInput = this.ymdToInput(date.value);
            this.to.selected = date.value;
            input.focus();
          }
        } else if (this.to.selected) {
          if (this.to.selected < date.value) {
            this.to.textInput = this.ymdToInput(date.value);
            this.to.selected = date.value;
            input.focus();
          } else {
            this.from.textInput = this.ymdToInput(date.value);
            this.from.selected = date.value;
          }
        } else {
          this.to.textInput = this.ymdToInput(date.value);
          this.to.selected = date.value;
          input.focus();
        }
        this.onConfirm();
      }
    },
    validateFromInput(newInput) {
      const newDate = this.convertDate(newInput);
      if (this.isRange) {
        const rtn = [
          `${this.ymdToModel(newDate)}${!newDate ? '' : ' ' + this.fromTime}`,
          `${this.ymdToModel(this.to.selected)}${!this.to.selected ? '' : ' ' + this.toTime}`
        ];
        this.from.textInput = this.ymdToInput(newDate);
        this.isSetCalender = false;
        this.$emit('update:modelValue', rtn);
      }
      return true;
    },
    validateToInput(newInput) {
      let newDate = this.convertDate(newInput);
      if (newDate) {
        const validVal = this.toValidRange([this.from.selected, newDate]);
        newDate = validVal[1];
      }
      if (this.isRange) {
        const rtn = [
          `${this.ymdToModel(this.from.selected)}${!this.from.selected ? '' : ' ' + this.fromTime}`,
          `${this.ymdToModel(newDate)}${!newDate ? '' : ' ' + this.toTime}`
        ];
        this.to.textInput = this.ymdToInput(newDate);
        this.isSetCalender = false;
        this.$emit('update:modelValue', rtn);
      }
      return true;
    },
    convertDate(newInput) {
      let newDate = this.inputToYmd(this.validateInputDate(newInput));
      newDate = this.toValidYmd(newDate);
      return newDate.split(' ')[0];
    },
    changeFromInput() {
      this.checkChangeInputDate();
    },
    changeToInput() {
      this.checkChangeInputDate();
    },
    checkChangeInputDate() {
      const startDate = this.convertDate(this.from.textInput);

      const endDate = this.convertDate(this.to.textInput);
      if (this.isRange) {
        const rtn = [
          `${this.ymdToModel(startDate)}${!startDate ? '' : ' ' + this.fromTime}`,
          `${this.ymdToModel(endDate)}${!endDate ? '' : ' ' + this.toTime}`
        ];

        this.$emit('changeInputDate', rtn);
      }
    },
    onConfirm() {
      // selected confirmed and want to be update v-model & actual date
      // close calendar
      let rtn;
      if (this.isRange) {
        rtn = [
          `${this.ymdToModel(this.from.selected)}${!this.from.selected ? '' : ' ' + this.fromTime}`,
          `${this.ymdToModel(this.to.selected)}${!this.to.selected ? '' : ' ' + this.toTime}`
        ];
        if (!this.isEqualArray(this.modelValue, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else {
          this.validateOnEvent();
        }
      } else {
        rtn = this.ymdToModel(this.from.selected);
        if (!this.isEqualModel(this.modelValue, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else {
          this.validateOnEvent();
        }
      }
      this.showFlag = 0;
    },
    setCalendarMonth(calendarMonth) {
      let YYYY, MM;
      if (Array.isArray(calendarMonth) && calendarMonth.length === 2) {
        this.calendarMonth = [];
        YYYY = parseInt(calendarMonth[0]);
        MM = parseInt(calendarMonth[1]);
        if (MM < 1) {
          YYYY -= 1;
          MM += 12;
        }
        if (MM > 12) {
          YYYY += 1;
          MM -= 12;
        }
        this.calendarMonth.push(YYYY);
        this.calendarMonth.push(MM);
      }
    },
    onClickOutside() {
      if (this.showFlag === 0) {
        return;
      }
      // set selected back to original value
      // close calendar
      let tmp;
      if (this.isRange) {
        this.onUpdate(this.showFlag);
      } else {
        this.from.textInput = this.ymdToInput(this.from.actualDate);
        this.from.selected = this.from.actualDate;
        if (this.from.actualDate) {
          tmp = this.from.actualDate.split('-');
        } else {
          tmp = this.today.split('-');
        }
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      }
      this.showFlag = 0;
    },
    onClickPrevMonth() {
      if (this.viewMode === 'year') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) - 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else if (this.viewMode === 'month') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) - 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]),
          parseInt(this.calendarMonth[1]) - 1
        ]);
      }
    },
    onClickNextMonth() {
      if (this.viewMode === 'year') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) + 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else if (this.viewMode === 'month') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) + 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]),
          parseInt(this.calendarMonth[1]) + 1
        ]);
      }
    },
    monthFilter(month, flag) {
      let m = parseInt(month[1]) - 2 + flag;
      let y = parseInt(month[0]);
      if (m < 0) {
        m = m + 12;
        y = y - 1;
      } else if (m > 11) {
        m = m - 12;
        y = y + 1;
      }
      m = m < 0 ? m + 12 : m > 11 ? m - 12 : m;
      return this.viewMode === 'day' ? this.monthAbbr[m] + ' ' + y : y;
    },
    decadeCalendar(calendarMonth) {
      let rtn = [],
        tmp = [];
      let yStr = String(calendarMonth[0]);
      let yyFrom = Number(yStr.slice(0, 3) + '0');
      let len = 10;

      for (let a = 0; a < len; a++) {
        tmp.push(yyFrom + a);
        if (a % 3 == 2) {
          rtn.push(tmp);
          tmp = [];
        }
      }
      if (tmp.length) {
        rtn.push(tmp);
      }
      return rtn;
    },
    yearCalendar() {
      return [
        [1, 2, 3],
        [4, 5, 6],
        [7, 8, 9],
        [10, 11, 12]
      ];
    },
    monthClass(month) {
      let rtn = [];
      rtn.push('lego-date-picker__calendar__month');
      if (month === this.calendarMonth[1]) rtn.push('lego-date-picker__calendar__month--selected');
      if (month === this.hoverMonth) rtn.push('lego-date-picker__calendar__month--hover');
      return rtn;
    },
    yearClass(year) {
      let rtn = [];
      rtn.push('lego-date-picker__calendar__year');
      if (year === this.calendarMonth[0]) rtn.push('lego-date-picker__calendar__year--selected');
      if (year === this.hoverYear) rtn.push('lego-date-picker__calendar__year--hover');
      return rtn;
    },
    modeChange(val) {
      this.viewMode = val;
    },
    onClickMonth(month) {
      if (this.month) {
        if (this.showFlag === 1) {
          this.from.selected = `${this.calendarMonth[0]}-${
            parseInt(month) < 10 ? `0${month}` : month
          }-01`;
          this.onConfirm();

          if (this.isRange) {
            this.showFlag = 2;
          }
        } else if (this.showFlag === 2) {
          this.to.selected = `${this.calendarMonth[0]}-${
            parseInt(month) < 10 ? `0${month}` : month
          }-01`;
          this.onConfirm();
        }
      } else {
        this.modeChange('day');
      }
      this.calendarMonth[1] = month;
      this.setCalendarMonth([parseInt(this.calendarMonth[0]), parseInt(this.calendarMonth[1])]);
      this.month || this.modeChange('day');
    },
    onClickYear(year) {
      if (this.year) {
        if (this.showFlag === 1) {
          this.from.selected = `${year}-01-01`;
          this.onConfirm();
          if (this.month) {
            this.modeChange('month');
          }
          if (this.isRange) {
            this.showFlag = 2;
          }
        } else if (this.showFlag === 2) {
          this.to.selected = `${year}-01-01`;
          this.onConfirm();
        }
      } else {
        this.month ? this.modeChange('month') : this.modeChange('day');
      }
      this.calendarMonth[0] = year;
      this.setCalendarMonth([parseInt(this.calendarMonth[0]), parseInt(this.calendarMonth[1])]);
    }
  }
};
</script>

<style lang="scss" scoped>
.lego-date-picker--up .lego-date-picker__calendar {
  top: auto !important;
}
@mixin lego-date-picker-calendar {
  &__calendar {
    &__date {
      @include font(14px);
    }
  }
  padding: 12px;
  width: 244px;
  top: 32px;
  &__row-content {
    span {
      @include font(12px, 700);
      color: $color--ui01;

      &.lego-date-picker__calendar__date.lego-date-picker__calendar__date--other-month,
      &.lego-date-picker__calendar__date.lego-date-picker__calendar__date--disabled {
        opacity: 0.2;
      }

      &.lego-date-picker__calendar__date--sunday {
        color: $color--status-error;
      }

      &.lego-date-picker__calendar__date {
        @include font(12px, 400);
      }

      &.lego-date-picker__calendar__date--today {
        color: $color--primary;
      }

      &.lego-date-picker__calendar__date--selected {
        color: $color--ui-white;
        @include font(12px, 700);
      }
    }
  }
  &__date {
    &-area {
      flex: 0 0 220px;
      margin-bottom: 0px;
    }
  }

  &__month__row {
    position: relative;
    height: 48px;
    width: 100%;
    margin-bottom: 8px;
    padding: 0 12px;
  }

  &__month__row-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    float: left;

    span {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      flex: 0 0 auto;
      border-radius: 50%;
      margin: 0 12px;
      @include font(14px);
    }
  }

  &__month {
    cursor: pointer;

    &:hover {
      color: $lego__font-color--default;
      background-color: $color--ui-10;
    }

    &.lego-date-picker__calendar__month--selected {
      color: $color--ui-white;
      background-color: $color--primary;
    }
  }

  &__year__row {
    position: relative;
    height: 48px;
    width: 100%;
    margin-bottom: 16px;
  }

  &__year__row-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    float: left;

    span {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      flex: 0 0 auto;
      border-radius: 50%;
      margin: 0 12px;
      outline: none;
      @include font(13px);
    }
  }

  &__year {
    cursor: pointer;

    &:hover {
      color: $lego__font-color--default;
      background-color: $color--ui-10;
    }

    &.lego-date-picker__calendar__year--selected {
      color: $color--ui-white;
      background-color: $color--primary;
    }
  }
}

.lego-date-picker {
  &__calendar--range {
    .lego-date-picker__calendar__month-area {
      justify-content: space-between;
    }

    left: 283px;
  }

  &-header {
    .lego-date-picker-type {
      @include font(16px, 700);
      color: $color--primary;

      &:hover {
        text-decoration: underline;
      }

      &:nth-of-type(2) {
        margin-left: 8px;
      }
    }
  }

  &-type {
    cursor: pointer;
  }

  &__text-field {
    width: 127px !important;
    min-width: 127px;
  }

  .lego-date-picker__calendar {
    @include lego-date-picker-calendar;
  }

  .lego-date-picker__icon-wrapper {
    border-left: 0;
  }

  &.lego-date-picker--medium {
    .lego-icon-wrapper {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
